import { NavLink } from "react-router-dom";

type Area = "tags";

type Props = {
  area: Area;
};

export function ResourcesSubnav({ area }: Props) {
  const items: { to: string; label: string; end: boolean; area: Area }[] = [
    { to: "/resources", label: "Wolne kolczyki", end: true, area: "tags" },
  ];

  return (
    <nav className="subnav" aria-label="Zasoby">
      {items.map((item) => (
        <NavLink
          key={item.to}
          to={item.to}
          end={item.end}
          className={() =>
            area === item.area ? "subnav__link subnav__link--active" : "subnav__link"
          }
        >
          {item.label}
        </NavLink>
      ))}
    </nav>
  );
}
